export default __webpack_public_path__ + "static/media/kim-jestesmy.263208e8.svg";